import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { DesktopHeader } from 'components/DesktopHeader';
import { getSearchDesktopHeaderHeight } from 'modules/search/selectors';
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "hkrrb4j",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  searchDesktopHeaderHeight
}) => `calc(100vh - ${searchDesktopHeaderHeight}px)`;
const ContentSectionElement = /*#__PURE__*/styled('section')({
  name: "ContentSectionElement",
  class: "c1f63dut",
  propsAsIs: false,
  vars: {
    "c1f63dut-0": [_exp()]
  }
});
interface PropsType {
  hasSearchForm: boolean;
  hasFixedHeader?: boolean;
  hasFilters?: boolean;
  hasSearchProgressBar?: boolean;
  customSearchBox?: React.ReactElement;
}
export const DesktopBaseLayout: React.FC<React.PropsWithChildren<PropsType>> = ({
  children,
  hasSearchForm,
  hasFilters = false,
  hasFixedHeader,
  hasSearchProgressBar = false,
  customSearchBox
}) => {
  const searchDesktopHeaderHeight = useSelector(getSearchDesktopHeaderHeight);
  return <>
      <HeaderWrapper>
        <DesktopHeader hasSearchForm={hasSearchForm} hasFilters={hasFilters} isFixed={hasFixedHeader} hasSearchProgressBar={hasSearchProgressBar} customSearchBox={customSearchBox} />
      </HeaderWrapper>

      <ContentSectionElement searchDesktopHeaderHeight={searchDesktopHeaderHeight}>
        {children}
      </ContentSectionElement>
    </>;
};

require("./BaseDesktop.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./BaseDesktop.tsx");